/*
  me-core.js — Coeur JS legitime restaure (base Dawn / Shrine Pro).
  Remplace le fichier "main.js" du theme qui avait ete detourne vers un
  script tiers malveillant (deshawnippin8888.serv00.net) ne fournissant plus
  les fonctions et composants du theme. Ce fichier redefinit uniquement ce
  qui manquait : utilitaires + composants panier/produit. Toutes les
  definitions sont protegees pour ne pas entrer en conflit avec secondary.js.
*/

/* ---------------- Utilitaires (global.js) ---------------- */
if (typeof window.getFocusableElements !== 'function') {
  window.getFocusableElements = function (container) {
    return Array.from(
      container.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
    );
  };
}

window.trapFocusHandlers = window.trapFocusHandlers || {};

if (typeof window.trapFocus !== 'function') {
  window.trapFocus = function (container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
      if (event.target !== container && event.target !== last && event.target !== first) return;
      document.addEventListener('keydown', trapFocusHandlers.keydown);
    };
    trapFocusHandlers.focusout = function () {
      document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };
    trapFocusHandlers.keydown = function (event) {
      if (event.code.toUpperCase() !== 'TAB') return;
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    if (elementToFocus) elementToFocus.focus();
    if (
      elementToFocus &&
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
}

if (typeof window.removeTrapFocus !== 'function') {
  window.removeTrapFocus = function (elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
    if (elementToFocus) elementToFocus.focus();
  };
}

if (typeof window.debounce !== 'function') {
  window.debounce = function (fn, wait) {
    let t;
    return function (...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  };
}

if (typeof window.throttle !== 'function') {
  window.throttle = function (fn, delay) {
    let last = 0;
    return function (...args) {
      const now = new Date().getTime();
      if (now - last < delay) return;
      last = now;
      return fn(...args);
    };
  };
}

if (typeof window.fetchConfig !== 'function') {
  window.fetchConfig = function (type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    };
  };
}

/* ---------------- Constantes + PubSub ---------------- */
if (typeof window.ON_CHANGE_DEBOUNCE_TIMER === 'undefined') {
  window.ON_CHANGE_DEBOUNCE_TIMER = 300;
}
if (typeof window.PUB_SUB_EVENTS === 'undefined') {
  window.PUB_SUB_EVENTS = {
    cartUpdate: 'cart-update',
    quantityUpdate: 'quantity-update',
    variantChange: 'variant-change',
    cartError: 'cart-error',
  };
}
if (typeof window.subscribe !== 'function') {
  window.MEsubscribers = window.MEsubscribers || {};
  window.subscribe = function (eventName, callback) {
    if (window.MEsubscribers[eventName] === undefined) window.MEsubscribers[eventName] = [];
    window.MEsubscribers[eventName] = [...window.MEsubscribers[eventName], callback];
    return function unsubscribe() {
      window.MEsubscribers[eventName] = window.MEsubscribers[eventName].filter((cb) => cb !== callback);
    };
  };
  window.publish = function (eventName, data) {
    if (window.MEsubscribers[eventName]) {
      window.MEsubscribers[eventName].forEach((cb) => cb(data));
    }
  };
}

/* ---------------- quantity-input ---------------- */
if (!customElements.get('quantity-input')) {
  customElements.define(
    'quantity-input',
    class QuantityInput extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true });
        this.querySelectorAll('button').forEach((button) =>
          button.addEventListener('click', this.onButtonClick.bind(this))
        );
      }
      onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;
        event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
      }
    }
  );
}

/* ---------------- cart-remove-button ---------------- */
if (!customElements.get('cart-remove-button')) {
  customElements.define(
    'cart-remove-button',
    class CartRemoveButton extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', (event) => {
          event.preventDefault();
          const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
          if (cartItems) cartItems.updateQuantity(this.dataset.index, 0);
        });
      }
    }
  );
}

/* ---------------- cart-items ---------------- */
if (!customElements.get('cart-items')) {
  class CartItems extends HTMLElement {
    constructor() {
      super();
      this.lineItemStatusElement =
        document.getElementById('shopping-cart-line-item-status') ||
        document.getElementById('CartDrawer-LineItemStatus');
      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, ON_CHANGE_DEBOUNCE_TIMER);
      this.addEventListener('change', this.debouncedOnChange.bind(this));
    }

    onChange(event) {
      this.updateQuantity(
        event.target.dataset.index,
        event.target.value,
        document.activeElement.getAttribute('name')
      );
    }

    getSectionsToRender() {
      return [
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items')
            ? document.getElementById('main-cart-items').dataset.id
            : null,
          selector: '.js-contents',
        },
        { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
        { id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' },
        {
          id: 'main-cart-footer',
          section: document.getElementById('main-cart-footer')
            ? document.getElementById('main-cart-footer').dataset.id
            : null,
          selector: '.js-contents',
        },
      ];
    }

    updateQuantity(line, quantity, name) {
      this.enableLoading(line);
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender()
          .map((section) => section.section)
          .filter(Boolean),
        sections_url: window.location.pathname,
      });
      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => response.text())
        .then((state) => {
          const parsedState = JSON.parse(state);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');
          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
          this.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section) => {
            const container = document.getElementById(section.id);
            if (!container || !section.section || !parsedState.sections[section.section]) return;
            const elementToReplace = container.querySelector(section.selector) || container;
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          });
          this.disableLoading(line);
        })
        .catch(() => {
          this.disableLoading(line);
        })
        .finally(() => {
          this.disableLoading(line);
        });
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    enableLoading(line) {
      const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
      if (mainCartItems) mainCartItems.classList.add('cart__items--disabled');
    }

    disableLoading(line) {
      const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
      if (mainCartItems) mainCartItems.classList.remove('cart__items--disabled');
    }
  }
  customElements.define('cart-items', CartItems);
  window.MECartItems = CartItems;
}

/* ---------------- cart-drawer-items (herite de cart-items) ---------------- */
if (!customElements.get('cart-drawer-items') && window.MECartItems) {
  customElements.define(
    'cart-drawer-items',
    class CartDrawerItems extends window.MECartItems {
      getSectionsToRender() {
        return [
          { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
          { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
        ];
      }
    }
  );
}

/* ---------------- cart-drawer ---------------- */
if (!customElements.get('cart-drawer')) {
  customElements.define(
    'cart-drawer',
    class CartDrawer extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        const overlay = this.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', this.close.bind(this));
        this.setHeaderCartIconAccessibility();
      }

      setHeaderCartIconAccessibility() {
        const cartLink = document.querySelector('#cart-icon-bubble');
        if (!cartLink) return;
        cartLink.setAttribute('role', 'button');
        cartLink.setAttribute('aria-haspopup', 'dialog');
        cartLink.addEventListener('click', (event) => {
          event.preventDefault();
          this.open(cartLink);
        });
        cartLink.addEventListener('keydown', (event) => {
          if (event.code.toUpperCase() === 'SPACE') {
            event.preventDefault();
            this.open(cartLink);
          }
        });
      }

      open(triggeredBy) {
        if (triggeredBy) this.setActiveElement(triggeredBy);
        setTimeout(() => {
          this.classList.add('animate', 'active');
        });
        this.addEventListener(
          'transitionend',
          () => {
            const containerToTrapFocusOn = this.classList.contains('is-empty')
              ? this.querySelector('.drawer__inner-empty')
              : document.getElementById('CartDrawer');
            const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
            if (containerToTrapFocusOn && focusElement) trapFocus(containerToTrapFocusOn, focusElement);
          },
          { once: true }
        );
        document.body.classList.add('overflow-hidden');
      }

      close() {
        this.classList.remove('active');
        removeTrapFocus(this.activeElement);
        document.body.classList.remove('overflow-hidden');
      }

      renderContents(parsedState) {
        this.productId = parsedState.id;
        this.getSectionsToRender().forEach((section) => {
          const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);
          if (!sectionElement || !parsedState.sections[section.id]) return;
          sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        });
        setTimeout(() => {
          const overlay = this.querySelector('#CartDrawer-Overlay');
          if (overlay) overlay.addEventListener('click', this.close.bind(this));
          this.open();
        });
      }

      getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
      }

      getSectionsToRender() {
        return [
          { id: 'cart-drawer', selector: '#CartDrawer' },
          { id: 'cart-icon-bubble' },
        ];
      }

      setActiveElement(element) {
        this.activeElement = element;
      }
    }
  );
}

/* ---------------- product-form ---------------- */
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        if (!this.form) return;
        const idInput = this.form.querySelector('[name=id]');
        if (idInput) idInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer') && this.submitButton)
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const spinner = this.querySelector('.loading-overlay__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            this.error = false;
            this.cart.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) this.errorMessage.textContent = errorMessage;
      }
    }
  );
}


/* ---------------- Filet de securite : garantir l'affichage du contenu ----------------
   Le script tiers retire gerait aussi la revelation du contenu (sections en
   .animate--hidden + <main> masque par un kill-switch). On garantit ici que
   rien ne reste cache, meme si un autre script echoue. */
(function () {
  function meMainVisible() {
    try { var m = document.querySelector('main'); if (m) m.style.visibility = 'visible'; } catch (e) {}
  }
  function meForceReveal() {
    try { var h = document.querySelectorAll('.animate-section, .animate--hidden'); for (var i = 0; i < h.length; i++) h[i].classList.add('animate--shown'); } catch (e) {}
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', meMainVisible); } else { meMainVisible(); }
  window.addEventListener('load', meMainVisible);
  setTimeout(function () { meMainVisible(); if (!document.querySelector('.animate-section.animate--shown')) meForceReveal(); }, 2500);
})();


/* ---------------- Traduction FR des aria-labels du slider (invisibles, a11y) ---------------- */
(function () {
  var MAP = {
    'Next slide': 'Diapositive suivante',
    'Previous slide': 'Diapositive précédente',
    'Go to first slide': 'Aller à la première diapositive',
    'Go to last slide': 'Aller à la dernière diapositive',
    'Select a slide to show': 'Sélectionner une diapositive',
    'Play': 'Lecture',
    'Pause': 'Pause'
  };
  function meAria() {
    try {
      var els = document.querySelectorAll('[aria-label]');
      for (var i = 0; i < els.length; i++) {
        var v = els[i].getAttribute('aria-label');
        if (MAP[v]) { els[i].setAttribute('aria-label', MAP[v]); continue; }
        var m = v && v.match(/^Go to slide (\d+)$/);
        if (m) els[i].setAttribute('aria-label', 'Aller à la diapositive ' + m[1]);
      }
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', meAria);
  else meAria();
  window.addEventListener('load', meAria);
  setTimeout(meAria, 900);
  setTimeout(meAria, 2000);
})();
